export const HeaderFontFamily = "Times-Semibold";
